import React, { useState, useEffect } from "react";
import { Table, Flex, Button, Typography } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import axios from "axios";
import API from "@/api";
import moment from "moment";
import IndexStatus from "./indexStatus";

function DrawerDetail(props) {
  const { selectedRow, onClick } = props;
  const [tableData, setTableData] = useState([]);

  const [loadedKeys, setLoadedKeys] = useState([]);
  const [loading, setLoading] = useState(true);

  const [name, setName] = useState("");
  const [id, setId] = useState("");

  useEffect(() => {
    axios.get(API.getNextZsklist + `?dirid=${selectedRow?.key}`).then((res) => {
      setTableData(res?.data?.result?.data || []);
      setLoading(false);
    });
  }, [selectedRow?.key]);

  // 模拟接口
  const fetchTreeData = (parentId) => {
    return new Promise((resolve) => {
      axios.get(API.getNextZsklist + `?dirid=${parentId}`).then((res) => {
        setTimeout(() => {
          resolve(res?.data?.result?.data || []);
        }, 500);
      });
    });
  };

  // 递归更新数据
  const updateTreeData = (data, targetId, newChildren) => {
    return data.map((node) => {
      if (node.id === targetId) return { ...node, children: newChildren };
      if (node.children)
        return {
          ...node,
          children: updateTreeData(node.children, targetId, newChildren),
        };
      return node;
    });
  };

  // 手动监听展开事件，实现动态加载
  const handleExpand = async (expanded, record) => {
    // 仅展开时加载，且未加载过的节点才请求
    if (expanded && !loadedKeys.includes(record.id)) {
      const childData = await fetchTreeData(record.id);
      const newData = updateTreeData(tableData, record.id, childData);
      setTableData(newData);
      setLoadedKeys([...loadedKeys, record.id]); // 标记为已加载
    }
  };

  // icon
  // :
  // "./static/media/wjj.f92e353cd5bb14f7ab0b55cabb6ceaa3.svg"
  // key
  // :
  // "gns://57421F8DF7284EDDAF784D6F4991A33F"
  // label
  // :
  // "杨洋(L2#####88)"
  // sj
  // :
  // "2025-12-26 12:04:35"
  // source
  // :
  // "我的文档库"
  // user
  // :
  // "杨洋(L2#####88)


  return (
    <>
      <Flex justify="space-between" align="center">
        <div>
          <Flex>
            <div>
              <img
                style={{
                  width: "60px",
                  height: "60px",
                }}
                src={selectedRow?.icon}
              />
            </div>
            <div
              style={{
                lineHeight: "30px",
                paddingLeft: "20px",
              }}
            >
              <div>
                <span
                  style={{
                    fontSize: "16px",
                    fontWeight: "600",
                  }}
                >
                  {selectedRow?.label}
                </span>
                <span
                  style={{
                    paddingLeft: "15px",
                    color: "#aaa",
                    fontSize: "14px",
                  }}
                >
                  {selectedRow?.source}
                </span>
              </div>
              <div
                style={{
                  color: "#aaa",
                }}
              >
                <span>
                  <span>所有者：</span>
                  <span>{selectedRow?.user}</span>
                </span>
                <span
                  style={{
                    paddingLeft: "15px",
                  }}
                >
                  <span>发布时间：</span>
                  <span>{moment(selectedRow?.sj).format("YYYY-MM-DD")}</span>
                </span>
              </div>
            </div>
          </Flex>
        </div>
        <Button
          icon={<PlusOutlined />}
          onClick={() => {
            window.open("https://kr.zju.edu.cn/anyshare/zh-cn/dir");
          }}
        >
          新建知识库
        </Button>
      </Flex>
      <div
        style={{
          padding: "10px 0",
        }}
      >
        <Table
          bordered
          rowKey="id"
          loading={loading}
          columns={[
            {
              title: "名称",
              dataIndex: "name",
            },
            {
              title: "所属者",
              dataIndex: "createdBy",
            },
            {
              title: "更新时间",
              dataIndex: "modifiedAt",
            },
            {
              title: "类型",
              dataIndex: "suffix",
            },
            {
              title: "大小",
              dataIndex: "size",
            },
            {
              title: "索引状态",
              dataIndex: "a",
              render(val, row) {
                if(row?.type === "file"){
                  return  <IndexStatus id={row?.id} />
                }else {
                  return ""
                }
              },
            },
            {
              title: "操作",
              dataIndex: "id",
              render(val, row) {
                return (
                  <span
                    style={{
                      color: "#1890FF",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      onClick?.(row);
                    }}
                  >
                    对话
                  </span>
                );
              },
            },
          ]}
          //   rowSelection={{
          //     onChange: (id, row) => {
          //       console.log(row);
          //       setName(row?.[0]?.name);
          //       setId(row?.[0]?.id);
          //     },
          //     type: "radio",
          //     checkStrictly: false,
          //     getCheckboxProps: (record) => {
          //       if (!record?.createdBy) {
          //         return {
          //           disabled: true,
          //           style: { display: "none" }, // 或者使用 className 隐藏
          //         };
          //       }
          //       return {};
          //     },
          //   }}
          dataSource={tableData}
          // ✅ 核心：用onExpand替代loadData，手动控制加载
          onExpand={handleExpand}
          treeProps={{
            childrenColumnName: "children",
            defaultExpandAll: false,
          }}
          pagination={false}
          style={{ margin: "20px" }}
        />
      </div>
    </>
  );
}

export default DrawerDetail;
